/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function () {
  function addHomeSectionClasses() {

    // ✅ This theme doesn't use template-index body class
    // So we check pathname instead
    var isHomePage = window.location.pathname === "/";

    if (!isHomePage) return;

    // ✅ From your theme.liquid line 95, main content has id="main"
    var sections = document.querySelectorAll("#main .shopify-section");

    // Fallback
    if (sections.length === 0) {
      sections = document.querySelectorAll(".shopify-section");
    }

    if (sections.length === 0) {
      console.warn("No .shopify-section found.");
      return;
    }

    sections.forEach(function (el) {
      el.classList.add("home-section");
    });

    console.log("✅ home-section added to " + sections.length + " section(s).");
  }

  // ✅ custom.js loads with defer so DOM is already ready
  addHomeSectionClasses();

})();

var theme_custom = theme_custom || {};
theme_custom.regionsToggle = function () {
  document.querySelectorAll(".product-region").forEach(function(item){
    item.addEventListener("click", function(){
      var parent = this.closest(".regions_toggle");
      parent.classList.toggle("active");
      var list = parent.querySelector(".supported-region-list");
    });
  });
};
document.addEventListener("DOMContentLoaded", function () {
  theme_custom.regionsToggle();
});




document.addEventListener('DOMContentLoaded', function() {

    const input = document.querySelector('.predictive-search__input');

    if (!input) return;

    const placeholders = [
        'Universal Travel Adapter',
        'European Plug Adapter',
        'Voltage Converter'
    ];

    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function typeEffect() {
        const currentWord = placeholders[wordIndex];

        if (isDeleting) {
            charIndex--;
        } else {
            charIndex++;
        }

        input.placeholder = currentWord.substring(0, charIndex);

        let speed = isDeleting ? 50 : 100;

        if (!isDeleting && charIndex === currentWord.length) {
            speed = 2000; // pause when fully typed
            isDeleting = true;
        } else if (isDeleting && charIndex === 0) {
            isDeleting = false;
            wordIndex = (wordIndex + 1) % placeholders.length;
            speed = 500; // pause before next word
        }

        setTimeout(typeEffect, speed);
    }

    typeEffect();
});

/*
(function() {
  var path = window.location.pathname;
  
  // Yeh pages skip karo
  var shouldSkip = 
    path === '/' ||
    path.startsWith('/collections') ||
    path.startsWith('/products') ||
    path.startsWith('/cart') ||
    path.startsWith('/checkout') ||
    path.startsWith('/search') ||
    path.startsWith('/account') ||
    path.startsWith('/password');
  
  if (!shouldSkip) {
    // Common class for all CMS pages
    document.body.classList.add('cms-page');
    
    // Page specific class
    var parts = path.split('/').filter(Boolean);
    if (parts.length >= 2) {
      document.body.classList.add(parts[0] + '-' + parts[1].replace(/[^a-z0-9-]/gi, '-'));
    }
  }
})(); */


(function() {
  var path = window.location.pathname;
  var parts = path.split('/').filter(Boolean);
  
  if (parts[0] === 'pages' && parts.length >= 2) {
    document.body.classList.add('cms-page');
    document.body.classList.add('pages-' + parts[1].replace(/[^a-z0-9-]/gi, '-'));
  }
})();
/**
 * Header center search suggestions (inline dropdown under the search bar).
 * Uses Shopify Predictive Search + section rendering; does not alter the search drawer.
 */
(function () {
  var root = document.querySelector('[data-header-search]');
  if (!root) return;

  var input = root.querySelector('[data-header-search-input]');
  var results = root.querySelector('[data-header-search-results]');
  if (!input || !results) return;

  var abortController = null;
  var debounceTimer = null;
  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 1;

  function setExpanded(isOpen) {
    input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    results.hidden = !isOpen;
  }

  function hideSuggestions() {
    setExpanded(false);
    results.innerHTML = '';
  }

  function showSuggestions(html) {
    results.innerHTML = html;
    setExpanded(true);
  }

  function supportsPredictiveSearch() {
    var featuresEl = document.getElementById('shopify-features');
    if (!featuresEl) return true;
    try {
      return !!JSON.parse(featuresEl.innerHTML).predictiveSearch;
    } catch (e) {
      return true;
    }
  }

  async function fetchSuggestions(term) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    var predictiveUrl = window.themeVariables.routes.predictiveSearchUrl;
    var url =
      predictiveUrl +
      '?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[options][fields]=title,product_type,variants.title,vendor' +
      '&section_id=header-search-suggestions';

    var response = await fetch(url, { signal: abortController.signal });
    var text = await response.text();
    var div = document.createElement('div');
    div.innerHTML = text;
    var section = div.querySelector('.shopify-section') || div.firstElementChild;
    return section ? section.innerHTML : '';
  }

  function onInput() {
    var term = input.value.trim();

    clearTimeout(debounceTimer);

    if (term.length < MIN_CHARS) {
      if (abortController) abortController.abort();
      hideSuggestions();
      return;
    }

    if (!supportsPredictiveSearch()) {
      hideSuggestions();
      return;
    }

    debounceTimer = setTimeout(async function () {
      try {
        var html = await fetchSuggestions(term);
        if (!html || !html.trim()) {
          hideSuggestions();
          return;
        }
        showSuggestions(html);
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        hideSuggestions();
      }
    }, DEBOUNCE_MS);
  }

  input.addEventListener('input', onInput);
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MIN_CHARS && results.innerHTML.trim()) {
      setExpanded(true);
    }
  });

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) {
      setExpanded(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !results.hidden) {
      hideSuggestions();
      input.blur();
    }
  });
})();